export function getIntegrationOfAttachedProtons(target, correlations) {
    const { H: attachment = [] } = target.attachment;
    let integration = 0;
    for (const match of attachment) {
        const correlation = correlations[match];
        integration += Number(correlation.link[0].signal.integration);
    }
    return integration;
}
//# sourceMappingURL=getIntegrationOfAttachedProtons.js.map